module.exports = __webpack_public_path__ + "img/productions_34.369a6dbd.png";